import { Component, OnInit } from '@angular/core';
import { Personnage } from '../_models/personnage';
import { CharacterSheetService } from '../_services/character-sheet.service';
import { ConfirmationDialogService } from '../confirmation-dialog/confirmation-dialog.service';

@Component({
  selector: 'app-character-sheets',
  templateUrl: './character-sheets.component.html',
  styleUrls: ['./character-sheets.component.scss']
})
export class CharacterSheetsComponent implements OnInit {
  public personnages!: Personnage[];

  constructor(private characterSheetService: CharacterSheetService, private confirmationDialogService: ConfirmationDialogService) {}

  ngOnInit(): void {
    this.characterSheetService.listPersonnages().subscribe(l => {
      this.personnages = l;
    });
  }

  public confirmDelete(personnage: Personnage): boolean {
    this.confirmationDialogService.confirm('Supprimer un personnage', 'Voulez-vous supprimer le personnage ' + personnage.nom + '?')
    .then((confirmed) => {
      if (confirmed) {
        this.characterSheetService.deletePersonnage({
          personnageId: personnage.id,
        })
        .subscribe({
          next: (result) => {
            this.personnages = this.personnages.filter(p => p.id != personnage.id);
          }
        });
      }
    })
    return false;
  }
}
